import { render, staticRenderFns } from "./VehicleMarketRegion.vue?vue&type=template&id=6f37a5f5&"
import script from "./VehicleMarketRegion.vue?vue&type=script&lang=js&"
export * from "./VehicleMarketRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports